<template>
  <v-container fluid class="bg-image">
    <v-row>
      <v-btn text color="white" @click="changeLang('en')">EN</v-btn>
      <p class="my-0 mt-1 white--text">|</p>
      <v-btn text color="white" @click="changeLang('fr')">FR</v-btn>
    </v-row>
    <v-layout justify-center>
      <v-flex xs12 sm8 md5 class="text-center">
        <v-img
          class="mt-5 mb-3"
          :src="imageLogoUrlWhite"
          :max-height="imageHeight"
          contain
          aspect-ratio="1.7"
        ></v-img>
        <v-card class="age-gate-transparent-card">
          <v-card-text class="px-5 py-1">
            <p
              class="text-center white--text subtitle-1 font-weight-bold pt-5"
            >{{$t('select_province_and_dob')}}</p>
            <v-form @submit.prevent ref="age-verification-form">
              <v-row justify-lg="center">
                <v-col cols="12" lg="8" class="ma-0 pa-0">
                  <v-select
                    :rules="[required($t('province_required'))]"
                    v-model="user.province"
                    item-text="name"
                    return-object
                    solo
                    flat
                    :items="provinces"
                    :label="$t('province')"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="8" class="ma-0 pa-0">
                  <input
                    v-if="this.$vuetify.breakpoint.mobile"
                    class="datepicker"
                    v-model="user.date"
                    type="date"
                  />
                  <v-menu
                    v-else
                    ref="menu"
                    :close-on-content-click="false"
                    :return-value.sync="user.date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        solo
                        flat
                        v-model="user.date"
                        :label="$t('date_of_birth')"
                        append-icon="mdi-event"
                        readonly
                        v-on="on"
                        :rules="[required($t('date_of_birth_required'))]"
                        @click.stop="triggerYearPicker"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      @click:date="$refs.menu.save(user.date)"
                      v-model="user.date"
                      min="1900-01-01"
                      :max="new Date().toISOString().substr(0, 10)"
                      ref="picker"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5 pt-0">
            <v-row>
              <v-col cols="12" class="ma-0 pa-0">
                <p class="caption white--text pa-0 mb-1">{{$t('legal_drinking_age_disclaimer')}}</p>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0">
                <p class="caption white--text pa-0 ma-0">
                  <a
                    @click="$router.push('/terms-and-conditions')"
                    target="_blank"
                    class="white--text a-underline"
                  >Travelzoo's Terms and Conditions</a>
                </p>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0">
                <p class="caption white--text pa-0">
                  <a
                    @click="$router.push('/privacy-policy-travelzoo')"
                    class="white--text a-underline"
                  >Travelzoo's Privacy Policy</a>
                </p>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0">
                <v-btn @click="enterSite" color="primary" class="px-10 btn-opacity">{{$t('enter')}}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <br />
        <br />
        <app-footer />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { diffInYears } from '@/utils/datetime'
import { required } from '@/utils/validations'
import { mapMutations } from 'vuex'
export default {
  components: {
    AppFooter: () => import('@/components/Footer.vue')
  },
  data () {
    return {
      user: {
        province: null,
        date: null
      },
      provinces: [
        {
          name: 'Alberta',
          abbreviation: 'AB',
          age: 18
        },
        {
          name: 'British Columbia',
          abbreviation: 'BC',
          age: 19
        },
        {
          name: 'Manitoba',
          abbreviation: 'MB',
          age: 18
        },
        {
          name: 'New Brunswick',
          abbreviation: 'NB',
          age: 19
        },
        {
          name: 'Newfoundland and Labrador',
          abbreviation: 'NL',
          age: 19
        },
        {
          name: 'Northwest Territories',
          abbreviation: 'NT',
          age: 19
        },
        {
          name: 'Nova Scotia',
          abbreviation: 'NS',
          age: 19
        },
        {
          name: 'Nunavut',
          abbreviation: 'NU',
          age: 19
        },
        {
          name: 'Ontario',
          abbreviation: 'ON',
          age: 19
        },
        {
          name: 'Prince Edward Island',
          abbreviation: 'PE',
          age: 19
        },
        {
          name: 'Quebec',
          abbreviation: 'QC',
          age: 18

        },
        {
          name: 'Saskatchewan',
          abbreviation: 'SK',
          age: 19
        },
        {
          name: 'Yukon Territory',
          abbreviation: 'YT',
          age: 19
        }
      ]
    }
  },
  methods: {
    required,
    ...mapMutations({
      setAgeVerificationStatus: 'Auth/SET_AGE_VERIFICATION_STATUS'
    }),
    async triggerYearPicker () {
      setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    enterSite () {
      if (!this.$refs['age-verification-form'].validate()) {
        return
      }
      if (!this.amIallowed) {
        return this.$snackbar({ text: 'Sorry, you are not of the legal drinking age to enter the website.', color: 'error', timeout: 5000 })
      }
      this.setAgeVerificationStatus(true)
      if (this.$route.query.redirect) {
        if (this.$route.query['auction-item-id']) {
          this.$router.push({ path: `${this.$route.query.redirect}&auction-item-id=${this.$route.query['auction-item-id']}` })
        } else {
          this.$router.push(this.$route.query.redirect)
        }
      } else {
        this.$router.push('/welcome')
      }
    }
  },
  computed: {
    amIallowed () {
      if (this.user.date === null || this.user.province === null) {
        return false
      }
      const userAge = diffInYears(this.user.date, new Date())
      return userAge > this.user.province.age
    },
    imageHeight () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '125px'
        case 'sm': return '150px'
        case 'md': return '225px'
        case 'lg': return '250px'
        case 'xl': return '250px'
        default: return '150px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-image {
  background: linear-gradient(
      0deg,
      rgba(2, 16, 48, 0.25),
      rgba(2, 16, 48, 0.25)
    ),
    url("../assets/images/Stock/background-image.jpg");
  /* Background image is centered vertically and horizontally at all times */
  background-position: center center;

  /* Background image doesn't tile */
  background-repeat: no-repeat;

  /* Background image is fixed in the viewport so that it doesn't move when
     the content's height is greater than the image's height */
  background-attachment: fixed;

  /* This is what makes the background image rescale based
     on the container's size */
  background-size: cover;

  /* Set a background color that will be displayed
     while the background image is loading */
}
.age-gate-transparent-card {
  background: rgba(255, 255, 255, 0.25)!important;
  border: 2px solid white !important;
}
.a-underline {
  text-decoration: underline;
}

[type="date"] {
  background: #fff
    url(https://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/calendar_2.png)
    97% 50% no-repeat;
  width: 100%;
  padding: 10px 10px;
  border-radius: 5px;
}
[type="date"]::-webkit-inner-spin-button {
  display: none;
}
</style>
